// extracted by mini-css-extract-plugin
export const root = "marquee-module--root--27Khz";
export const marquee__wrapper = "marquee-module--marquee__wrapper--6jCAX";